import React from 'react';
import FeaturedAuthorTutoring from '../FeaturedAuthorTutoring';

import imageSrc from './wes.png';

const WesTutoring = () => {
  return (
    <FeaturedAuthorTutoring
      imageSrc={imageSrc}
      description={
        <div>
          <p>
            Your coach Wes Carroll, who wrote this course, has{' '}
            <a
              href="https://wescarroll.com/competition/?utm_source=achievable"
              target="_blank"
              rel="noopener noreferrer"
            >
              helped students master the AMC and reach the AIME for over 20 years.
            </a>{' '}
            He can help you, too.
          </p>
          <p>
            Have a parent visit{' '}
            <a
              href="http://wescarroll.com/start/?utm_source=achievable"
              target="_blank"
              rel="noopener noreferrer"
            >
              his site
            </a>{' '}
            to schedule a chat, so that you can get unstuck, break through any plateau,
            and qualify for the AIME (and beyond).
          </p>
        </div>
      }
      url="http://wescarroll.com/start/?utm_source=achievable"
      cta="Visit Wes's site"
    />
  );
};

export default WesTutoring;
